/**
 * Hook for accessing and controlling the current theme (light/dark/system).
 */

import { useContext } from "react";
import { ThemeContext, type ThemeContextValue } from "@/providers/theme-provider";

/**
 * Access the current theme and the setTheme function.
 * Must be used within a ThemeProvider.
 */
export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);
  return context;
}
